import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiCheckbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { colors } from '../../theme/colors';
import { iconPaths } from '../../../react/constants/icons';

const CustomCheckbox = withStyles({
	root: {
		color: colors['silver-grey'],
		'&$checked': {
			color: colors['silver-grey'],
		},
	},
	checked: {},
})((props: CheckboxProps) => <MuiCheckbox color="default" {...props} />);

type CheckboxTypes = {
	checked?: boolean;
	defaultChecked?: boolean;
	handleChange?: () => void;
	id?: string;
	label?: string;
	disabled?: boolean;
	style?: any;
};

const Checkbox = ({ checked, defaultChecked, handleChange, id, label, disabled, style, ...props }: CheckboxTypes): JSX.Element => {
	return (
		<FormControlLabel
			style={{ marginLeft: -9, ...style }}
			control={
				<CustomCheckbox
					disabled={disabled}
					icon={
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
							<path fill={colors['silver-grey']} d="M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z" />
						</svg>
					}
					checkedIcon={
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
							<path fill={colors['silver-grey']} d="M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z" />
							<path d={iconPaths.check} />
						</svg>
					}
					checked={checked}
					defaultChecked={defaultChecked}
					onChange={handleChange}
					id={id}
				/>
			}
			label={label}
			{...props}
		/>
	);
};

export default Checkbox;
